import React, { FunctionComponent } from "react";
import ReanalyzeFormInput, {
  LAYOUT_TYPE
} from "../reanalyze-form-input/ReanalyzeFormInput";
import ReanalyzeCardContainer from "../reanalyze-card-container/ReanalyzeCardContainer";
import { AnalysisTypeInfo } from "../../../../header/hooks/usePrepareReanalyzeData";

type ReanalyzeIntegrationsFormInputProps = {
  name: string;
  label: string;
  analysisInfo?: AnalysisTypeInfo;
  selected: boolean;
  onToggle: (fieldName: string) => void;
  disabled?: boolean;
  layout?: string;
};

const ReanalyzeIntegrationsFormInput: FunctionComponent<
  ReanalyzeIntegrationsFormInputProps
> = ({
  name,
  label,
  analysisInfo,
  selected,
  onToggle,
  disabled,
  layout = LAYOUT_TYPE.COL
}) => {
  const isHidden = !analysisInfo?.enabled;
  const isDisabled = analysisInfo?.queue_filled || disabled;

  return (
    <ReanalyzeCardContainer
      key={name}
      hidden={isHidden}
      selected={selected}
      layout={layout}
      onClick={() => {
        if (isDisabled) {
          return;
        }

        onToggle(name);
      }}
      disabled={isDisabled}
      tooltipMessage={
        isDisabled ? analysisInfo?.additional_information : undefined
      }
      classNameOuterContainer={"mb-10"}
    >
      <ReanalyzeFormInput
        name={name}
        label={label}
        labelIcon={name}
        labelIconSize={16}
        helpImportant={
          isDisabled ? undefined : analysisInfo?.additional_information
        }
        timestamp={analysisInfo?.last_completed_on}
        layout={layout}
        checked={selected}
        disabled={isDisabled}
      />
    </ReanalyzeCardContainer>
  );
};

export default ReanalyzeIntegrationsFormInput;
